// extracted by mini-css-extract-plugin
export default {"carCard":"CarElement_carCard__SD-Mq","selected":"CarElement_selected__ee57Z"};